import React, { Component } from 'react';
import {connect} from 'mirrorx';

const styles = {
	footerContent: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		width: '100%',
		height: '100%'
	}
}

class Footer extends Component {
	constructor() {
		super();
		this.renderDirty = this.renderDirty.bind(this);

	}
	renderDirty() {
		return this.props.editor.isDirty ? '*' : null;
	}

	__renderNormalFooter = () => {
		return (
			<div style={styles.footerContent}>
				{this.props.editor.stats.words}W {this.props.editor.stats.characters}C - {this.props.editor.file.service} - {this.props.editor.file.path}{this.props.editor.file.name}{this.renderDirty()}
			</div>
		);
	}

	__renderLoadingFooter = () => {
		return (
			<div style={styles.footerContent}>
			Loading...
			</div>
		);
	}

	render() {
		return this.props.layout.loading ? this.__renderLoadingFooter() : this.__renderNormalFooter();
	}
}


export default connect(state => {
  return {editor: state.editor,
  	layout: state.layout}
})(Footer)


// WEBPACK FOOTER //
// ./src/components/footer.js